<!--
  同種藥物用的多重藥盒取藥, 補藥
-->

<template>
  <div>
    <Action 
      v-if="stage === 'action'"
      v-on:setActionData="getThisAmount" 
      :defaultNum="forAction.defaultNum"
      :deviceId="forAction.deviceId"
      :inputReadOnly="false"
      :defaultPackCount="amountPayload.packCount"
      :limitPackCount="false"
      :checkNum="forAction.checkNum" >
      <h5>此藥盒補藥數量</h5>
    </Action>
  </div>
</template>

<script>
import Action from '../flowComp/Action';

export default {
  name: 'RefillAction',
  props: ['amountPayload', 'startType'], // amount: 補充數量
  components: {
    Action,
  },
  computed: {
    currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    DrugStorageWithSameDrugID() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrugID;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
  data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      DeviceInQueue: [], // device queue with same drug
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0,
      },
      emitTimes: 0,
    };
  },
  beforeCreate() {
    this.totalAmount = 0;
    this.DeviceInQueue = [];
    this.actionData = [];
  },
  created() {
    if (this.startType === 'createNewDrugStorage') {
      this.forAction = {
        defaultNum: this.amountPayload.amount,
        checkNum: this.amountPayload.maxAmount,
        deviceId: this.$store.state.device.currentDevice.id,
      };
    } else {
      // prepare for the first Action child.
      this.DeviceInQueue = this.DrugStorageWithSameDrugID;
      console.log(this.DeviceInQueue);
      console.log(this.currentDrugInDevice.id);
      this.DeviceInQueue.pop(this.DeviceInQueue.indexOf(this.currentDrugInDevice.id));
      this.forAction = {
        defaultNum: this.amountPayload.amount,
        checkNum: this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock,
        deviceId: this.currentDrugInDevice.device.id,
      };
    }
    this.stage = 'action';
  },
  methods: {
    goOn() {
      this.stage = 'action';
    },
    getThisAmount(data) {
      if (this.emitTimes === 0) {
        this.emitTimes += 1;
        console.log(data);
        console.log(this.amount, this.totalAmount);
        // data: device, num
        this.totalAmount += data.num;
        this.actionData.push(data);
        console.log(this.totalAmount);

        if (this.totalAmount < this.amount) {
          setInterval(() => {
            this.goOn();
          }, 200);
          // go and take drug from another device.
          const nextDrugStorageId = this.DeviceInQueue.pop(0);
          console.log('[next drugstorageid]', nextDrugStorageId);

          this.instance.get(`/api/drug-storage/${nextDrugStorageId}`)
          .then((res) => {
            const data = res.data;
            this.forAction = {
              defaultNum: this.amountPayload.amount - this.totalAmount, // the resident number for child.
              checkNum: data.stock,
              deviceId: data.device.id,
            };
            console.log(this.forAction);
          });
        } else {
          this.$emit('setActionData', this.actionData);
          // this.emitTimes = 0;
          console.log('finished');
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// ActionWrap.vue?5bab01cd